<template>
  <v-container>
      <v-row class="sub-bar">
        <v-btn
          class="app-bar__button"
          fab
          to="/projects/new"
          >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-row>
      <v-card
          class="pa-2"
          outlined
          v-if=" user && projects.length == 0"
        >
      <div>
      <p class="fibl-headline form__subheadline" v-if="user.name">
        {{this.$i18n.t('projectsView.welcomeText.welcomeWithName')}}
        <span 
          class="fibl-headline form__subheadline"
        >
        {{user.name}}{{"."}}
        </span>       
      </p>

      <p class="fibl-headline form__subheadline" v-else>
        {{this.$i18n.t('projectsView.welcomeText.welcome')}}       
      </p>
      <p></p>
      <p></p>    
      <p class = "user__profile_details"
      > 
      {{this.$i18n.t('projectsView.welcomeText.projectsMessage1')}}
      </p>
        <div class="password-forgot-user-profile"
         @click="newProject()" 
        >
      {{this.$i18n.t('projectsView.welcomeText.projectsMessage2')}}
          </div>
        </div>
      </v-card>
      <v-data-table v-else
            class="data-table__projects"
            :headers="headers"
            :items="projects"
            hide-default-footer
            sort-by="created_on"
            :options.sync="options"
            @click:row="editItem"
          >
            <template v-slot:item.name="{ item }">
              <span v-if="!isEditing(item)"> {{ item.name }}</span>
              <v-text-field
                v-else
                class="project-name"
                autofocus
                dense
                :hint="hint"
                v-model="projectName"
                v-on:blur="cancelInput()"
                v-on:keyup.enter="setName(item)"
                v-on:click.stop
              />
            </template>

            <template v-slot:item.regions="{ item }">
              <v-chip 
                v-for="r in item.regions" 
                :key="r.id" 
              >{{getRegionName(r)}}</v-chip>
            </template>

            <template v-slot:item.created_on="{ item }">
              <span>{{ new Date(item.created_on).toLocaleString() }}</span>
              
            </template>

            <template v-slot:item.demand_fulfillments="{ item }">
             <div class="text-center">
                <span  class="counter" @click="goToDemandFulfillmentsList(item)">
                  {{ item.demand_fulfillments.length }}
                </span>
              </div>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-menu
                bottom
                left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon medium color="grey">
                      mdi-dots-horizontal
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(elem, i) in context_menu"
                    :key="i"
                    @click="elem.action(item)"
                  >
                    <v-list-item-title>{{ elem.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>

          </v-data-table>

    <new-demand-fulfillment-dialog ref="dialog"
      :visible="showNewDialog"
      @close="closeDialog"
      persistent
    />
    <delete-dialog
    :visible="this.deleteModal"
    @closeDelete="closeDelete"
    v-bind:project="this.selectedProject"
    />

    
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import store from "@/store/index";
import NewDemandFulfillmentDialog from '../components/dialogs/NewDemandFulfillmentDialog.vue';
import DeleteDialog from '../components/dialogs/DeleteDialog.vue';

export default {
  name: "ProjectsView",

  components: { NewDemandFulfillmentDialog, DeleteDialog },

  data() {
    return { 
      
    DeleteDialogedit: null,
      name: null,
      hint: null,
      context_menu: [
        {
          title: this.$i18n.t('contextMenu.duplicate'),
          action: function(project) {
            store.dispatch("duplicateProject", project);
          },
        },

        { 
          title: this.$i18n.t('contextMenu.cover') ,
          action: function(project) {
            store.dispatch("fetchProject", project.project_id);
            this.comp._data.showNewDialog = true;
          }
        },

        {
          title: this.$i18n.t('contextMenu.rename'),
          action: function(project) {
            this.comp.setEditable(project);
          },
        },

        {
          title: this.$i18n.t('contextMenu.remove'),
          action: async function(project) {
              this.comp._data.deleteModal = true;
              this.comp._data.selectedProject = project;
          },
        },
      ],
      options: {
        itemsPerPage: 15,
      },
      headers: [
        {
          text: this.$i18n.t('projectsView.dataTable.name'),
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: this.$i18n.t('projectsView.dataTable.region'), value: "regions", sortable: false },
        { text: this.$i18n.t('projectsView.dataTable.date'), value: "created_on" },
        { text: this.$i18n.t('projectsView.dataTable.covers'), value: "demand_fulfillments", sortable: false, align: "center" },
        { text: "", value: "actions", sortable: false },
      ],
      edited_item: 0,
      showNewDialog: false,
      deleteModal: false, 
      selectedProject: null,
    };
  },

  computed: {
    ...mapState(["project", "projects", "regions", "user", "showModal"]),

    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },

    projectName: {
      set(val) {
        if (val === null) {
          this.name = this.edit.name;
        } else {
          this.name = val;
        }
      },
      get() {
        return this.edit.name;
      },
    },

    showModal () {
      return this.$store.state.showModal;
    }
  },

  mounted() {
    this.$store.dispatch("fetchProjects");
    this.$store.dispatch("fetchRegions");

    // store a reference to the component in each menu entry in order to be able to call methods on the component instance
    this.context_menu.forEach((m) => (m.comp = this));
    this.$store.commit('setPageTitle', this.$i18n.t('app.title.pageTitle'));
  },

  methods: {
    newProject() {
      this.$router.push('/projects/new');
    },

    closeDialog() {
      this.showNewDialog = false;
    },

    closeDelete() {
      this.deleteModal = false;
      this.selectedProject = null;
    },

    goToDemandFulfillmentsList(item) {
      this.currentProject = Object.assign({}, item);
      this.$router.push(this.currentProject.project_id + "/fulfillment/list");
    },

    startNewProject() {
      this.$store.commit("newProject");
      this.$router.push(this.project.project_id + "/plant");
    },

    getRegionNames(region_ids) {
      return region_ids
        .flatMap((id) =>
          this.regions.filter((r) => r.id == id).map((r) => r['name_'+this.$i18n.locale])
        )
        .join(", ");
    },

    getRegionName(id) {
      let region = this.regions.find((r) => r.id == id);
      return region ? region['name_'+this.$i18n.locale] : "";
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.$router.push(this.editedItem.project_id + "/plant");
    },

    setName(project) {
      let tmpNames = this.projects.map((p) => p.name);
      if (this.name === null) {
        this.name = this.edit.name;
      }

      if (
        (!tmpNames.includes(this.name.trim()) && this.name.length > 0) ||
        this.name === this.edit.name
      ) {
        this.$store.dispatch("setProjectName", {
          name: this.name.trim(),
          id: project.project_id,
        });
        this.$store.dispatch("fetchProjects");
      }
    },

    duplicateProject(item) {
      this.$store.dispatch("duplicateProject", item);
    },

    setEditable(item) {
      this.edit = item;
    },

    isEditing(item) {
      return this.edit == item;
    },

    cancelInput() {
      this.hint = null;
      this.name = this.edit.name;
      this.edit = null;
    },
  },

  watch: {
    name: function(val) {
      if (val === null) {
        val = this.edit.name;
      }
      let tmpNames = this.projects.map((p) => p.name);

      if (tmpNames.includes(val.trim()) && val.trim() != this.edit.name) {
        this.hint = this.$i18n.t('projectsView.dataTable.duplicateName');
      } else if (val.length < 1) {
        this.hint = this.$i18n.t('projectsView.dataTable.emptyName');
      } else {
        this.hint = null;
      }
    },
  },
};
</script>
